import Vue from "vue";
import VueI18n from "vue-i18n";
import th from "./lang/th";
import en from "./lang/en";
import appConfig from "@/config/application";

const messages = {
  th: th,
  en: en
};

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: appConfig.currentLocale,
  messages
});
